const ns = "FORMS_V2_FORM";
export const RECEIVE = `${ns}_RECEIVE`;
export const REQUEST = `${ns}_REQUEST`;
export const UPDATE = `${ns}_UPDATE`;
export const UPDATE_COMPLETE = `${ns}_UPDATE_COMPLETE`;
export const DELETE = `${ns}_DELETE`;
export const ERROR = `${ns}_ERROR`;
export const CLEAR_ERROR = `${ns}_CLEAR_ERROR`;
export const INVALIDATE = `${ns}_INVALIDATE`;
